import LoadingCard from "../LoadingCard";

const ReportGenerationLoader = ({ completed }) => (
  <div className="py-8">
    <LoadingCard
      message="Generating deep analysis report…"
      subMessage="Analyzing scientific literature and extracting key insights."
      progress={completed ? 100 : undefined}
    />
  </div>
);

export default ReportGenerationLoader;
